
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 18","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.468 12.042a5.356 5.356 0 01-.004-7.586 5.383 5.383 0 017.602.003 5.356 5.356 0 01.003 7.586 5.383 5.383 0 01-7.601-.003zM2.624 2.619a7.95 7.95 0 00.003 11.26 7.993 7.993 0 0010.36.794l2.918 2.696c.527.487 1.345.45 1.826-.082a1.318 1.318 0 00-.083-1.847l-2.84-2.625a7.953 7.953 0 00-.902-10.192C10.79-.487 5.739-.49 2.624 2.619z"}})])
          )
        }
      }
    